import axios, { AxiosResponse } from 'axios';
import { getAccessTokenBrowser } from 'helpers/auth';
import { postApiUrl } from './constants';

export type PostPaymentResult = Record<string, never>;

export const postPayment = async (hostname: string, data: string): Promise<AxiosResponse<PostPaymentResult>> => {
	const accessToken = await getAccessTokenBrowser();
	const { href } = postApiUrl(`NetsPayment/createpayment`);
	return axios.post<PostPaymentResult>(href, data, {
		headers: { hostname, Authorization: 'Bearer ' + accessToken, 'Content-Type': 'application/json' },
	});
};
